import i18next from 'i18next';

i18next.addResources('es', 'fundingSelector', {
  all: 'Todos',
  funding: 'Financiamiento',
  public: 'Público',
  private: 'Privado',
  mixed: 'Mixto'
});

i18next.addResources('en', 'fundingSelector', {
  all: 'All',
  funding: 'Funding',
  public: 'Public',
  private: 'Private',
  mixed: 'Mixed'
});

i18next.addResources('pt', 'fundingSelector', {
  all: 'Todos',
  funding: 'Financiamento',
  public: 'Público',
  private: 'Privado',
  mixed: 'Misto'
});
